import { render, staticRenderFns } from "./UsuarioDetalle.vue?vue&type=template&id=7f10b4cf&scoped=true"
import script from "./UsuarioDetalle.vue?vue&type=script&lang=js"
export * from "./UsuarioDetalle.vue?vue&type=script&lang=js"
import style0 from "./UsuarioDetalle.vue?vue&type=style&index=0&id=7f10b4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10b4cf",
  null
  
)

export default component.exports